var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 256",
    style: {
      enableBackground: "new 0 0 1000 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#206B8F;}\t.st1{fill:#F6A74F;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,172.8c-8.3-4.3-14.8-10.4-19.5-18.2c-4.7-7.8-7.1-16.6-7.1-26.5c0-9.9,2.4-18.7,7.1-26.5   c4.7-7.8,11.2-13.9,19.5-18.2c8.3-4.3,17.7-6.5,28-6.5c9.5,0,18,1.7,25.5,5c7.5,3.4,13.6,8.2,18.5,14.6L342.3,115   c-6.1-7.7-13.2-11.5-21.4-11.5c-6.9,0-12.5,2.2-16.7,6.7c-4.2,4.4-6.3,10.4-6.3,17.9c0,7.5,2.1,13.4,6.3,17.9   c4.2,4.4,9.8,6.7,16.7,6.7c8.2,0,15.4-3.8,21.4-11.5l20.9,18.6c-4.9,6.4-11,11.2-18.5,14.6c-7.5,3.4-16,5-25.5,5   C308.8,179.3,299.5,177.1,291.2,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.9,79V177h-32.5v-31.4c-6.5,2-12.5,2.9-17.8,2.9c-14.4,0-25.3-3.4-32.9-10.2   c-7.5-6.8-11.3-16.8-11.3-29.8V79H401v25.9c0,6,1.3,10.4,3.9,13.2c2.6,2.9,6.6,4.3,11.9,4.3c5.5,0,10-0.7,13.6-2.2V79H462.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M561.8,152.1V177h-81.5V79H560v24.9h-47.2v11.5h41.5v23.8h-41.5v12.9H561.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M658.8,104.6H630V177h-32.5v-72.4h-28.7V79h89.9V104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.7,79h32.5v51L736,79h31.1V177h-32.5v-50.9L700.9,177h-31.2V79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M867.9,104.6h-28.7V177h-32.5v-72.4H778V79h89.9V104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M898.9,172.7c-8.4-4.4-15-10.5-19.8-18.3c-4.8-7.8-7.1-16.6-7.1-26.4s2.4-18.6,7.1-26.4   c4.8-7.8,11.3-13.9,19.8-18.3c8.4-4.4,17.9-6.6,28.4-6.6c10.6,0,20,2.2,28.4,6.6c8.4,4.4,15,10.5,19.8,18.3   c4.8,7.8,7.1,16.6,7.1,26.4s-2.4,18.6-7.1,26.4c-4.8,7.8-11.3,13.9-19.8,18.3c-8.4,4.4-17.9,6.6-28.4,6.6   C916.8,179.3,907.3,177.1,898.9,172.7z M938.5,149.5c3.3-2,6-4.9,7.9-8.5c2-3.7,2.9-8,2.9-13c0-4.9-1-9.3-2.9-13   c-2-3.7-4.6-6.5-7.9-8.5c-3.3-2-7-3-11.1-3c-4.1,0-7.8,1-11.1,3c-3.3,2-6,4.9-7.9,8.5c-2,3.7-2.9,8-2.9,13c0,5,1,9.3,2.9,13   c2,3.7,4.6,6.5,7.9,8.5c3.3,2,7,3,11.1,3C931.4,152.5,935.2,151.5,938.5,149.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 107.3,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 158,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 207.2,
    r: 14.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,12.5H38.3c-11.6,0-21,9.4-21,21v189c0,11.6,9.4,21,21,21H192c11.6,0,21-9.4,21-21v-189   C213,21.9,203.6,12.5,192,12.5z M47.5,143.2c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8   C32.7,149.8,39.3,143.2,47.5,143.2z M32.7,107.3c0-8.2,6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8   C39.3,122.1,32.7,115.5,32.7,107.3z M140.1,222H47.5c-8.2,0-14.8-6.6-14.8-14.8s6.6-14.8,14.8-14.8h92.7c8.2,0,14.8,6.6,14.8,14.8   S148.3,222,140.1,222z M92.7,143.2c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8   C78,149.8,84.6,143.2,92.7,143.2z M78,107.3c0-8.2,6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8   C84.6,122.1,78,115.5,78,107.3z M138,143.2c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8   C123.2,149.8,129.8,143.2,138,143.2z M123.2,107.3c0-8.2,6.6-14.8,14.8-14.8c8.2,0,14.8,6.6,14.8,14.8c0,8.2-6.6,14.8-14.8,14.8   C129.8,122.1,123.2,115.5,123.2,107.3z M197.9,58.9c0,6-4.8,10.8-10.8,10.8h-68.9l-5,5c-2.1,2.1-5,3.3-8,3.3c-3,0-5.8-1.2-8-3.3   l-5-5H43.5c-6,0-10.8-4.8-10.8-10.8V38.5c0-6,4.8-10.8,10.8-10.8h85.1l6-6c2.1-2.1,4.9-3.3,7.9-3.3s5.8,1.2,7.9,3.3   c1.6,1.6,2.7,3.7,3.1,6h33.6c6,0,10.8,4.8,10.8,10.8V58.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 107.3,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 158,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.2,
    cy: 207.2,
    r: 14.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,71.6L83.3,54.3c-2.5-2.5-2.5-6.6,0-9.2l0,0c2.5-2.5,6.6-2.5,9.2,0l12.7,12.7l32.7-32.7     c2.5-2.5,6.6-2.5,9.2,0v0c2.5,2.5,2.5,6.6,0,9.2l-37.2,37.2C107.3,74.2,103.1,74.2,100.5,71.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3bc10a6e1032d01296188bf57d9eeed.svg";
export { ForwardRef as ReactComponent };